module.exports = {
      id: "instagram-plain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-b11c226f9ecc9a258e9645c9abf2e2fd.svg#instagram-plain",
      toString: function () {
        return this.url;
      }
    }